// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2UdzR","empty":"ModalGraph_empty__13rYw"};